export const QA_NAME_APPLICANT_CREDIT_CHECK = 'applicantCreditCheck'

export const QA_NAME_APPLICANT_CREDIT_CHECK_BAND = 'applicantCreditCheckBand'

export const QA_NAME_APPLICANT_CREDIT_CHECK_PROVIDER =
  'applicantCreditCheckProvider'

export const QA_NAME_APPLICANT_CREDIT_CHECK_EXPIRED =
  'applicantCreditCheckExpired'

export const QA_NAME_APPLICANT_CREDIT_CHECK_RETRY = 'applicantCreditCheckRetry'

export const QA_NAME_APPLICANT_CREDIT_CHECK_SUPPLEMENTARY =
  'applicantCreditCheckSupplementary'

export const QA_NAME_APPLICANT_CREDIT_CHECK_GATE = 'applicantCreditCheckGate'

export const QA_NAME_APPLICANT_CREDIT_CHECK_SUGGESTION =
  'applicantCreditCheckSuggestion'

export const QA_NAME_APPLICANT_CREDIT_CHECK_SUGGESTION_SOURCE =
  'applicantCreditCheckSuggestionSource'

export const QA_NAME_APPLICANT_CREDIT_CHECK_SUGGESTION_REVIEW =
  'applicantCreditCheckSuggestionReview'

export const QA_NAME_APPLICANT_CREDIT_CHECK_SUGGESTION_DISMISS =
  'applicantCreditCheckSuggestionDismiss'

export const QA_NAME_APPLICANT_CREDIT_CHECK_SUGGESTION_DISMISS_CONFIRM =
  'applicantCreditCheckSuggestionDismissConfirm'

export const QA_NAME_APPLICANT_CREDIT_CHECK_GATE_ACKNOWLEDGE =
  'applicantCreditCheckGateAcknowledge'

export const QA_NAME_APPLICANT_CREDIT_CHECK_ACTION = {
  attach: 'applicantCreditCheckAttach',
  correctVerdict: 'applicantCreditCheckCorrectVerdict',
  recordConsent: 'applicantCreditCheckRecordConsent',
  recordVerdict: 'applicantCreditCheckRecordVerdict',
  reminder: 'applicantCreditCheckReminder',
  request: 'applicantCreditCheckRequest',
  requestUpdated: 'applicantCreditCheckRequestUpdated',
  supplementary: 'applicantCreditCheckSupplementaryAttach',
}

export const APPLICANT_CREDIT_CHECK_PROVIDER_TEXT_COLOR =
  'var(--secondary-text-color)'

export const APPLICANT_CREDIT_CHECK_ACTION_LABEL_KEY = {
  attach: 'RentalPortal.ApplicantCreditCheckAttachBtnKey',
  correctVerdict: 'RentalPortal.ApplicantCreditCheckCorrectVerdictBtnKey',
  recordConsent: 'RentalPortal.ApplicantCreditCheckRecordConsentBtnKey',
  recordVerdict: 'RentalPortal.ApplicantCreditCheckRecordVerdictBtnKey',
  reminder: 'RentalPortal.ApplicantCreditCheckReminderBtnKey',
  request: 'RentalPortal.ApplicantCreditCheckRequestBtnKey',
  requestUpdated: 'RentalPortal.ApplicantCreditCheckRequestUpdatedBtnKey',
  supplementary: 'RentalPortal.ApplicantCreditCheckAttachSupplementaryBtnKey',
}

export const APPLICANT_CREDIT_CHECK_GATE_TITLE_KEY = {
  reminder: 'RentalPortal.ApplicantCreditCheckGateReminderTitleKey',
  request: 'RentalPortal.ApplicantCreditCheckGateTitleKey',
}

export const APPLICANT_CREDIT_CHECK_ROW = {
  consent: 'consent',
  consentVersion: 'consentVersion',
  expiresAt: 'expiresAt',
  issuedAt: 'issuedAt',
  remindedAt: 'remindedAt',
  requestedAt: 'requestedAt',
  satisfiedBy: 'satisfiedBy',
  verificationCode: 'verificationCode',
  verifiedAt: 'verifiedAt',
}

export const APPLICANT_CREDIT_CHECK_SUGGESTION_STATUS = {
  dismissed: 'dismissed',
  pending: 'pending',
}

export const APPLICANT_CREDIT_CHECK_STATUS = {
  consentGiven: 'consent_given',
  consentPending: 'consent_pending',
  documentAttached: 'document_attached',
  expired: 'expired',
  notRequested: 'not_requested',
  recorded: 'recorded',
  requested: 'requested',
}

export const APPLICANT_CREDIT_CHECK_ACTION = {
  attach: 'attach',
  correctVerdict: 'correctVerdict',
  recordConsent: 'recordConsent',
  recordVerdict: 'recordVerdict',
  reminder: 'reminder',
  request: 'request',
  requestUpdated: 'requestUpdated',
  supplementary: 'supplementary',
}

export const APPLICANT_CREDIT_CHECK_STATUS_ACTIONS = {
  [APPLICANT_CREDIT_CHECK_STATUS.consentGiven]: [
    APPLICANT_CREDIT_CHECK_ACTION.request,
    APPLICANT_CREDIT_CHECK_ACTION.attach,
  ],
  [APPLICANT_CREDIT_CHECK_STATUS.consentPending]: [
    APPLICANT_CREDIT_CHECK_ACTION.request,
    APPLICANT_CREDIT_CHECK_ACTION.recordConsent,
    APPLICANT_CREDIT_CHECK_ACTION.attach,
  ],
  [APPLICANT_CREDIT_CHECK_STATUS.documentAttached]: [
    APPLICANT_CREDIT_CHECK_ACTION.recordVerdict,
    APPLICANT_CREDIT_CHECK_ACTION.attach,
  ],
  [APPLICANT_CREDIT_CHECK_STATUS.expired]: [
    APPLICANT_CREDIT_CHECK_ACTION.requestUpdated,
    APPLICANT_CREDIT_CHECK_ACTION.supplementary,
    APPLICANT_CREDIT_CHECK_ACTION.correctVerdict,
  ],
  [APPLICANT_CREDIT_CHECK_STATUS.notRequested]: [
    APPLICANT_CREDIT_CHECK_ACTION.request,
    APPLICANT_CREDIT_CHECK_ACTION.recordConsent,
  ],
  [APPLICANT_CREDIT_CHECK_STATUS.recorded]: [
    APPLICANT_CREDIT_CHECK_ACTION.supplementary,
    APPLICANT_CREDIT_CHECK_ACTION.correctVerdict,
  ],
  [APPLICANT_CREDIT_CHECK_STATUS.requested]: [
    APPLICANT_CREDIT_CHECK_ACTION.reminder,
    APPLICANT_CREDIT_CHECK_ACTION.attach,
    APPLICANT_CREDIT_CHECK_ACTION.recordVerdict,
  ],
}

export const APPLICANT_CREDIT_CHECK_SENSITIVE_ACTIONS = [
  APPLICANT_CREDIT_CHECK_ACTION.correctVerdict,
  APPLICANT_CREDIT_CHECK_ACTION.recordVerdict,
]

export const APPLICANT_CREDIT_CHECK_UPLOAD_ACTIONS = [
  APPLICANT_CREDIT_CHECK_ACTION.attach,
  APPLICANT_CREDIT_CHECK_ACTION.supplementary,
]

export const APPLICANT_CREDIT_CHECK_PRIMARY_ACTIONS = [
  APPLICANT_CREDIT_CHECK_ACTION.recordVerdict,
  APPLICANT_CREDIT_CHECK_ACTION.request,
  APPLICANT_CREDIT_CHECK_ACTION.requestUpdated,
]

export const APPLICANT_CREDIT_CHECK_ACTION_ORDER = [
  APPLICANT_CREDIT_CHECK_ACTION.request,
  APPLICANT_CREDIT_CHECK_ACTION.requestUpdated,
  APPLICANT_CREDIT_CHECK_ACTION.reminder,
  APPLICANT_CREDIT_CHECK_ACTION.recordVerdict,
  APPLICANT_CREDIT_CHECK_ACTION.recordConsent,
  APPLICANT_CREDIT_CHECK_ACTION.attach,
  APPLICANT_CREDIT_CHECK_ACTION.supplementary,
  APPLICANT_CREDIT_CHECK_ACTION.correctVerdict,
]

export const APPLICANT_CREDIT_CHECK_GATE_MODE = {
  reminder: 'reminder',
  request: 'request',
}

export const APPLICANT_CREDIT_CHECK_UPLOAD_MAX_FILES = 1

export const APPLICANT_CREDIT_CHECK_SKELETON_ROWS = 3

export const APPLICANT_CREDIT_CHECK_REQUEST_ERROR_NOTIFICATION_ID =
  'applicantCreditCheckRequestError'
